import React, { Component, Fragment } from 'react'
import styles from './groups-component.styles'
import injectSheet from 'react-jss'
import Spinner from 'pobble-components/dist/spinner'
import {
  GroupsSelectionProvider,
  GroupsSelection
} from 'pobble-components/dist/groups-selection'
import { ModalContent } from 'pobble-components/dist/modal'
import GroupsModalFooter from '../groups-modal-footer/groups-modal-footer.container'

class GroupsComponent extends Component {
  componentDidMount() {
    this.props.onMount()
  }
  render() {
    const { classes, pending, groups, categories, selectedGroups } = this.props
    return (
      <GroupsSelectionProvider
        selected={selectedGroups}
        groups={groups}
        categories={categories}>
        {store => (
          <Fragment>
            <ModalContent legacy className={classes.content}>
              {pending && (
                <div className={classes.pending}>
                  <Spinner />
                </div>
              )}
              {!pending && (
                <GroupsSelection className={classes.groupsSelection} />
              )}
            </ModalContent>
            <GroupsModalFooter
              disabled={pending}
              selectedGroups={store.selectedGroups}
            />
          </Fragment>
        )}
      </GroupsSelectionProvider>
    )
  }
}

export default injectSheet(styles)(GroupsComponent)
